<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'un Pôle</span>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div v-else class="columns is-gapless is-padding-top is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-8 is-7-widescreen is-6-fullhd is-padding-right">
        <div class="has-bg-white is-border">
          <form @submit.prevent.stop="submit()">
            <div class="columns is-multiline">
              <div class="column is-9 is-padding-bottom-xsmall">
                <v-input id="name" name="name" :model="pole.name" label="Nom du Pôle *"
                        v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                        data-vv-as="Nom du Pôle" @input="val => pole.name = val">
                </v-input>
              </div>
              <div class="column is-12 is-margin-top is-paddingless is-border-top columns">
                <div class="column is-6">
                  <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
                </div>
                <div class="column is-6">
                  <button class="button is-success is-uppercase is-fullwidth has-text-white" type="submit"
                          :disabled="!canSubmit || loading" :class="{'is-loading':loading}">
                    <span v-if="!loading">Valider</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PoleCreate',
    data () {
      return {
        loading: false,
        pole: {},
        route: this.$route
      }
    },
    computed: {
      canSubmit () {
        return this.errors.any() === false
      }
    },
    methods: {
      submit () {
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              this.loading = true
              this.$api.poleService.post(this.pole).then(res => {
                this.loading = false
                this.$notify({
                  type: 'is-success',
                  text: 'Le pôle a bien été créé'
                })
                this.$router.push({name: 'PoleVue', params: {id: res.data.pk}})
              }).catch(() => {
                this.loading = false
                this.$notify({
                  type: 'is-danger',
                  text: 'Erreur lors de la création du pôle.'
                })
              })
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pole/PoleCreate.vue